import { toast } from "react-toastify";
import { api } from "./api";

export const requestApi = async ({
    method = "get",
    url,
    data = null,
    params = null,
    messages = {
        pending: "Cargando...",
        success: "Listo",
        error: "Algo salió mal",
    },
}) => {
    try {
        const res = await toast.promise(
            api({
                method,
                url,
                data,
                params,
            }),
            messages,
            { position: "top-center" }
        );

        return res.data;
    } catch (err) {
        console.log("Error:", err?.response?.data || err.message);

        return {
            ok: false,
            msg: err?.response?.data?.msg || "Algo salió mal",
            error: err?.response?.data || err.message,
        };
    }
};